import { initializeApp } from "firebase/app";
import { getAuth, GoogleAuthProvider, browserLocalPersistence, setPersistence } from "firebase/auth";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyCS-RtvYl98vyJFN6OTNfNOVKYtLX_ZTpk",
  authDomain: "dreamfulness-yogyism.firebaseapp.com",
  projectId: "dreamfulness-yogyism",
  storageBucket: "dreamfulness-yogyism.firebasestorage.app",
  messagingSenderId: "25647816647",
  appId: "1:25647816647:web:08e47a2e900dcfdb9103e2"
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const googleProvider = new GoogleAuthProvider();
export const db = getFirestore(app);
// ✅ force local persistence
setPersistence(auth, browserLocalPersistence);